import React from "react";
import { Box, Grid, Typography, TextField, Button, IconButton, Autocomplete, FormControl, InputLabel, Select, MenuItem, InputAdornment, FormGroup, FormControlLabel, Checkbox, RadioGroup, Radio, FormLabel } from "@mui/material";
import { Close } from "@mui/icons-material";
import moment from "moment";

export default function AddPermit(props) {

  return (
    <Box component="form" onSubmit={props.handleSubmit} sx={{ p: 3 }}>
      <Grid container spacing={3} sx={{ placeContent: "center" }}>
        <Grid item xs={6}>
          <Typography variant="subtitle1" color="primary" className="font-bold m-2 font-gray">
            {props.btn} {props.literals.permit}
          </Typography>
        </Grid>
        <Grid item xs={6} align='right'>
          <IconButton color="primary" aria-label="upload picture" component="label" onClick={props.onClose}>
            <Close />
          </IconButton>
        </Grid>
        <Grid item xs={12}>
          <Autocomplete
            disablePortal
            id="combo-box-demo"
            options={props.organizations}
            getOptionLabel={(option) => option.org_name}
            value={props.selectedOrg}
            readOnly={(props.user?.result?.role !== 'root') ? true : false}
            onChange={(event, newValue) => props.onOrgSelected(newValue)}
            renderInput={(params) => (
              <TextField {...params} label={props.literals.select_organization} color="primary" size="small" required />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Autocomplete
            disablePortal
            id="combo-box-demo"
            options={props.zones}
            getOptionLabel={(option) => option.zone_name}
            value={props.selectedZone}
            onChange={(event, newValue) => props.setSelectedZone(newValue)}
            renderInput={(params) => (
              <TextField {...params} label={props.literals.select_zone} color="primary" size="small" required />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            select
            label={props.literals.permit_type}
            color="primary"
            type="text"
            name="permit_type"
            value={props.inputField["permit_type"]}
            onChange={props.handleChange}
            size="small"
            required
            fullWidth
          >
            <MenuItem value={'monthly'}>Monthly</MenuItem>
            <MenuItem value={'yearly'}>Yearly</MenuItem>
            <MenuItem value={'custom'}>Custom</MenuItem>
          </TextField>
        </Grid>
        <Grid item xs={12}>
          <TextField
            id="standard-error-helper-text"
            label={props.literals.permit_name}
            color="primary"
            type="text"
            name="permit_name"
            value={props.inputField["permit_name"]}
            onChange={props.handleChange}
            size="small"
            required
            fullWidth
          />
        </Grid>
        {props.inputField["permit_type"] == 'custom' && <>
          <Grid item xs={6}>
            <TextField
              id="standard-error-helper-text"
              label={props.literals.permit_start_date}
              color="primary"
              type="date"
              name="permit_start_date"
              value={props.inputField["permit_start_date"]}
              onChange={props.handleChange}
              size="small"
              InputLabelProps={{ shrink: true }}
              required
              fullWidth
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              id="standard-error-helper-text"
              label={props.literals.permit_end_date}
              color="primary"
              type="date"
              name="permit_end_date"
              value={props.inputField["permit_end_date"]}
              onChange={props.handleChange}
              size="small"
              InputLabelProps={{ shrink: true }}
              InputProps={{inputProps: { min: moment(props.inputField["permit_start_date"]).format('YYYY-MM-DD')} }}
              required
              fullWidth
            />
          </Grid>
        </>}
        {props.inputField["permit_type"] && props.inputField["permit_type"] !== 'custom' && <Grid item xs={12}>
          <TextField
            id="standard-error-helper-text"
            label={props.inputField["permit_type"] == 'monthly' ? props.literals.no_of_months : props.literals.no_of_years}
            color="primary"
            type="number"
            name="no_of_months_year"
            value={props.inputField["no_of_months_year"]}
            onChange={props.handleChange}
            size="small"
            required
            fullWidth
          />
        </Grid>}
        {props.inputField["permit_type"] && props.inputField["permit_type"] !== 'custom' && <Grid item xs={12}>
          <TextField
            id="standard-error-helper-text"
            label={props.literals.renew_before}
            color="primary"
            type="number"
            name="renew_before"
            value={props.inputField["renew_before"]}
            onChange={props.handleChange}
            size="small"
            required
            InputProps={{
              endAdornment: <InputAdornment position="end">
                {props.literals.days}
              </InputAdornment>
            }}
            fullWidth
          />
        </Grid>}
        <Grid item xs={12}>
          <TextField
            label={props.literals.rate_in_cents}
            color="primary"
            type="number"
            name="rate"
            value={props.inputField["rate"]}
            onChange={props.handleChange}
            size="small"
            required
            fullWidth
          />
        </Grid>
        <Grid item xs={5}>
          <FormGroup>
            <FormControlLabel control={
              <Checkbox
                name="enable_permit_limit"
                onChange={props.handleCheck}
                checked={props.inputField['enable_permit_limit']}
              />} label={
                <Typography variant="subtitle1" color="primary" className="font-gray">
                  {props.literals.enable_permit_limit}
                </Typography>
              } />
          </FormGroup>
        </Grid>
        <Grid item xs={7}>
          {props.inputField['enable_permit_limit'] && <TextField
            label={props.literals.no_of_permits_allowed}
            color="primary"
            type="number"
            name="no_of_permits_allowed"
            value={props.inputField["no_of_permits_allowed"]}
            onChange={props.handleChange}
            size="small"
            required
            fullWidth
          />}
        </Grid>
        {props.inputField["permit_type"] && props.inputField["permit_type"] !== 'custom' && <Grid item xs={12}>
          <FormControl>
            <FormLabel>{props.literals.auto_renew_permission}</FormLabel>

            <RadioGroup row name="auto_renew_permission">
              <FormControlLabel value="enable_auto_renew_option" sx={{ color: "#000" }} control={
                <Radio
                  checked={props.inputField["auto_renew_permission"] === 'enable_auto_renew_option'}
                  onChange={props.handleChange}
                />} label={
                  <Typography variant="subtitle1" color="primary" className="font-gray">
                    {props.literals.enable_auto_renew_option}
                  </Typography>} />
              <FormControlLabel value="restrict_auto_renew" sx={{ color: "#000" }} control={
                <Radio
                  checked={props.inputField["auto_renew_permission"] === 'restrict_auto_renew'}
                  onChange={props.handleChange}
                />} label={
                  <Typography variant="subtitle1" color="primary" className="font-gray">
                    {props.literals.restrict_auto_renew}
                  </Typography>} />
            </RadioGroup>
          </FormControl>
        </Grid>}
        <Grid item xs={12} align="right">
          <Button
            type="button"
            color="secondary"
            variant="contained"
            onClick={props.onClose}
            size="small"
            sx={{ mx: 2 }}>
            {props.literals.cancel}
          </Button>
          <Button
            type="submit"
            color="primary"
            variant="contained"
            size="small">
            {props.btn}
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}
